import { Image } from '@shared/api/media/media.interface';
import { QueryDataState } from '@shared/interfaces';

import { User } from '../user/user.interface';

export enum EnquiryType {
  Bugo = 'Bugo',
  Store = 'Store',
  Seller = 'Seller',
  /** 로그인 화면의 [문의 남기기] — 비로그인 (백엔드 docs/login-help-enquiry.md) */
  LoginHelp = 'LoginHelp',
}

export const ENQUIRY_TYPE_LABEL: Record<EnquiryType, string> = {
  [EnquiryType.Bugo]: '부고',
  [EnquiryType.Store]: '스토어',
  [EnquiryType.Seller]: '셀러',
  [EnquiryType.LoginHelp]: '로그인 문의',
};

/** 로그인 문의 빠른 선택지. 제목은 서버가 이 값으로 정한다 */
export enum LoginHelpPreset {
  ForgotUsername = 'ForgotUsername',
  ForgotPassword = 'ForgotPassword',
  DeviceLocked = 'DeviceLocked',
  PhoneChanged = 'PhoneChanged',
  Other = 'Other',
}

export const LOGIN_HELP_PRESET_LABEL: Record<LoginHelpPreset, string> = {
  [LoginHelpPreset.ForgotUsername]: '아이디가 생각나지 않아요',
  [LoginHelpPreset.ForgotPassword]: '비밀번호가 생각나지 않아요',
  [LoginHelpPreset.DeviceLocked]: '로그인이 잠겼어요',
  [LoginHelpPreset.PhoneChanged]: '휴대폰 번호가 바뀌었어요',
  [LoginHelpPreset.Other]: '기타',
};

export interface LoginHelpEnquiryDto {
  preset: LoginHelpPreset;
  name: string;
  phoneNumber: string;
  /** preset 이 Other 면 필수, 아니면 선택 (500자) */
  content?: string;
  /** 로그인하려던 아이디 (선택) — 관리자가 잠금 해제 페이지에서 바로 찾는다 */
  username?: string;
}

export enum EnquiryStatus {
  Todo = 'Todo',
  Doing = 'Doing',
  Done = 'Done',
}

export type Enquiry<User = string, Image = string | null> = {
  _id: string;
  user: User;
  type: EnquiryType;
  title: string;
  name: string;
  phoneNumber: string;
  content: string;
  image: Image; // 이미지 없으면 ""
  answer: string;
  status: EnquiryStatus;
  //* 답변 제출(Done) 시 접수자에게 답변 LMS를 1회 보낸 시각. 발송 성공 시에만 기록되며
  //* 구서버·도입(2026-09-04) 전 답변·발송 실패면 없다. 비동기 발송이라 제출 직후엔 잠시 비어 있을 수 있다.
  answerNotifiedAt?: Date | string | null;
  createdAt: Date;
  updatedAt: Date;
};

export type EnquiryCreate = Omit<
  Enquiry,
  '_id' | 'createdAt' | 'updatedAt' | 'answer' | 'answerNotifiedAt'
>;

export type EnquiryList = Enquiry<User, Image>[];

export type EnquiryListState = QueryDataState<EnquiryList>;

export type UserEnquiryList = Enquiry<string, Image>[];

export type UserEnquiryListState = QueryDataState<UserEnquiryList>;

export type EnquiryUpdate = Pick<Enquiry, '_id' | 'answer' | 'status'>;
